import { useEffect, useState, useRef } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../firebase";
import { setServerTime } from "../utils/serverTimeStore";
import getServerOffset from "../utils/getServerOffset";

const SEC_MS = 1000;

export default function useServerClock(enabled = true) {
  const [serverTimeMs, setServerTimeMs] = useState(null);
  const [user, loading] = useAuthState(auth);

  const intervalRef = useRef(null);
  const startedRef = useRef(false);

  // Fix: Extract complex expression to a variable for the dependency array
  const hasUser = !!user; 

  useEffect(() => {
    // Check loading and user status
    if (!enabled || loading || !hasUser || startedRef.current) return;

    startedRef.current = true;
    let isMounted = true;

    const initClock = async () => {
      try {
        const offset = await getServerOffset();
        
        if (!isMounted) return;

        const update = () => {
          const now = Date.now() + offset;
          setServerTimeMs(now);
          setServerTime(now);
        };

        update();
        intervalRef.current = setInterval(update, SEC_MS);

      } catch (err) {
        console.error("useServerClock init failed:", err.message);
        startedRef.current = false; 
      }
    };

    initClock();

    return () => {
      isMounted = false;
      if (intervalRef.current) clearInterval(intervalRef.current);
      // We don't reset startedRef here to prevent spamming on re-renders
    };
    
    // Fix: Include 'user' (via hasUser) and 'enabled'/'loading' properly
  }, [enabled, loading, hasUser]); 

  return serverTimeMs;
}